module.exports = __webpack_public_path__ + "img/wanyuelogo.82cb9d88.png";